import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { ProductContext } from "../../../context/ProductContext";
import { PRODUCT_CHUNK } from "../../../utils/global_const";
import { useTranslation } from "react-i18next";
import ProductCard from "../../../components/product/ProductCard";
import Filter from "../../../components/product/Filter";
import ProductCardHorizontal from "../../../components/product/ProductCardHorizontal";
import ShopSort from "../../../components/product/ShopSort";

const Container = styled.article`
  color: ${(props) => props.theme.textColor};
`;
const Section = styled.section`
  width: 100%;
  @media (min-width: 1025px) {
    max-width: var(--max-width-container);
  }
`;
const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: ${({ $viewMode }) =>
    $viewMode === "grid" ? "repeat(2, 1fr)" : "repeat(1, 1fr)"};
  gap: var(--spacing-lg) 4px;

  @media (min-width: 768px) and (max-width: 1024px) {
    grid-template-columns: ${({ $viewMode }) =>
      $viewMode === "grid" ? "repeat(3, 1fr)" : "1fr 1fr"};
    gap: 12px;
  }

  @media (min-width: 1025px) {
    grid-template-columns: ${({ $viewMode }) =>
      $viewMode === "grid" ? "repeat(5, 1fr)" : "1fr 1fr 1fr"};
    gap: 12px;
  }
`;
const FlexDiv = styled.div`
  height: var(--navbar-height);
  //position: sticky;
  //left: 0;
  //top: calc(var(--navbar-height) + var(--navbar-mini));
  //flex-direction: row-reverse;

  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-large);

  @media (min-width: 768px) {
    //max-width: 90%;
    box-shadow: none;
    flex-direction: row;
    position: static;
    margin-bottom: 20px;
  }
  @media (min-width: 1025px) {
    max-width: var(--max-width-container);
  }
`;
const TopWrapper = styled.div`
  width: 94%;
  display: flex;
  //width: 94%;
  justify-content: space-between;
  align-items: center;
  @media (min-width: 768px) {
    flex-direction: row;
  }
`;
const FlexContainer = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;
  gap: 6px;
`;

const ViewButton = styled.button`
  padding: 6px;
  margin: 0;
  background-color: ${({ $isActive }) =>
    $isActive ? "var(--primary-100)" : "var(--bg-200)"};
  border: none;
`;

const PaginationContainer = styled(FlexContainer)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
  @media (min-width: 768px) {
    justify-content: flex-end;
  }
`;

const PageButton = styled.button`
  padding: 8px 12px;
  border: 1px solid ${({ isActive }) => (isActive ? "var(--primary)" : "#ccc")};
  background-color: ${({ isActive }) =>
    isActive ? "var(--primary-100)" : "#fff"};
  color: ${({ isActive }) => (isActive ? "#fff" : "#333")};
  font-weight: ${({ isActive }) => (isActive ? "bold" : "normal")};
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${({ isActive }) =>
      isActive ? "var(--primary-200)" : "#eee"};
  }
`;

const NavButton = styled.button`
  padding: 8px 16px;
  border: none;
  background-color: var(--bg-200);
  border: 1px solid var(--bg-300);
  font-weight: bold;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s ease;
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};

  &:hover {
    background-color: var(--primary-200);
  }
`;
const BestSellerMain = () => {
  const { t } = useTranslation();
  const { filteredProducts, bestSellers, setProducts } =
    useContext(ProductContext);
  const [viewMode, setViewMode] = useState("grid");

  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(filteredProducts.length / PRODUCT_CHUNK);

  // Funkcija za dobijanje proizvoda za trenutnu stranicu
  const currentProducts = filteredProducts.slice(
    (currentPage - 1) * PRODUCT_CHUNK,
    currentPage * PRODUCT_CHUNK
  );

  // Resetovanje na prvu stranicu kada se promeni filtrirana lista proizvoda
  useEffect(() => {
    setCurrentPage(1);
  }, [filteredProducts]);
  useEffect(() => {
    setProducts(bestSellers);
  }, [bestSellers]);

  // Funkcije za navigaciju između stranica
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
    window.scrollTo({
      top: 80,
      behavior: "smooth",
    });
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
    window.scrollTo({
      top: 80,
      behavior: "smooth",
    });
  };

  const renderPageNumbers = () => {
    const pages = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <PageButton
          key={i}
          onClick={() => {
            setCurrentPage(i);
            window.scrollTo({
              top: 80,
              behavior: "smooth",
            });
          }}
          isActive={i === currentPage}
        >
          {i}
        </PageButton>
      );
    }
    return pages;
  };
  return (
    <Container>
      <Section className="header-top-margin">
        <FlexDiv>
          <TopWrapper>
            <Filter />
            <FlexContainer>
              <ViewButton
                $isActive={viewMode === "grid"}
                onClick={() => setViewMode("grid")}
                aria-label={t("ARIA.GRID_VIEW")}
              >
                <svg
                  width="24px"
                  height="24px"
                  viewBox="0 -0.5 21 21"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>grid [#1526]</title>
                  <desc>Created with Sketch.</desc>
                  <defs></defs>
                  <g
                    id="Page-1"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g
                      id="Dribbble-Light-Preview"
                      transform="translate(-219.000000, -200.000000)"
                      fill={
                        viewMode == "grid" ? "var(--bg-100)" : "var(--text-100)"
                      }
                    >
                      <g
                        id="icons"
                        transform="translate(56.000000, 160.000000)"
                      >
                        <path
                          d="M181.9,54 L179.8,54 C178.63975,54 177.7,54.895 177.7,56 L177.7,58 C177.7,59.105 178.63975,60 179.8,60 L181.9,60 C183.06025,60 184,59.105 184,58 L184,56 C184,54.895 183.06025,54 181.9,54 M174.55,54 L172.45,54 C171.28975,54 170.35,54.895 170.35,56 L170.35,58 C170.35,59.105 171.28975,60 172.45,60 L174.55,60 C175.71025,60 176.65,59.105 176.65,58 L176.65,56 C176.65,54.895 175.71025,54 174.55,54 M167.2,54 L165.1,54 C163.93975,54 163,54.895 163,56 L163,58 C163,59.105 163.93975,60 165.1,60 L167.2,60 C168.36025,60 169.3,59.105 169.3,58 L169.3,56 C169.3,54.895 168.36025,54 167.2,54 M181.9,47 L179.8,47 C178.63975,47 177.7,47.895 177.7,49 L177.7,51 C177.7,52.105 178.63975,53 179.8,53 L181.9,53 C183.06025,53 184,52.105 184,51 L184,49 C184,47.895 183.06025,47 181.9,47 M174.55,47 L172.45,47 C171.28975,47 170.35,47.895 170.35,49 L170.35,51 C170.35,52.105 171.28975,53 172.45,53 L174.55,53 C175.71025,53 176.65,52.105 176.65,51 L176.65,49 C176.65,47.895 175.71025,47 174.55,47 M167.2,47 L165.1,47 C163.93975,47 163,47.895 163,49 L163,51 C163,52.105 163.93975,53 165.1,53 L167.2,53 C168.36025,53 169.3,52.105 169.3,51 L169.3,49 C169.3,47.895 168.36025,47 167.2,47 M181.9,40 L179.8,40 C178.63975,40 177.7,40.895 177.7,42 L177.7,44 C177.7,45.105 178.63975,46 179.8,46 L181.9,46 C183.06025,46 184,45.105 184,44 L184,42 C184,40.895 183.06025,40 181.9,40 M174.55,40 L172.45,40 C171.28975,40 170.35,40.895 170.35,42 L170.35,44 C170.35,45.105 171.28975,46 172.45,46 L174.55,46 C175.71025,46 176.65,45.105 176.65,44 L176.65,42 C176.65,40.895 175.71025,40 174.55,40 M169.3,42 L169.3,44 C169.3,45.105 168.36025,46 167.2,46 L165.1,46 C163.93975,46 163,45.105 163,44 L163,42 C163,40.895 163.93975,40 165.1,40 L167.2,40 C168.36025,40 169.3,40.895 169.3,42"
                          id="grid-[#1526]"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </ViewButton>
              <ViewButton
                $isActive={viewMode === "horizontal"}
                onClick={() => setViewMode("horizontal")}
                aria-label={t("ARIA.LIST_VIEW")}
              >
                <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 6L21 6.00078M8 12L21 12.0008M8 18L21 18.0007M3 6.5H4V5.5H3V6.5ZM3 12.5H4V11.5H3V12.5ZM3 18.5H4V17.5H3V18.5Z"
                    stroke={
                      viewMode !== "grid" ? "var(--bg-100)" : "var(--text-100)"
                    }
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </ViewButton>
              <ShopSort />
            </FlexContainer>
          </TopWrapper>
        </FlexDiv>
        <ProductGrid $viewMode={viewMode}>
          {viewMode === "grid"
            ? currentProducts.map((product, index) => (
                <ProductCard key={index} product={product} />
              ))
            : currentProducts.map((product, index) => (
                <ProductCardHorizontal key={index} product={product} />
              ))}
        </ProductGrid>

        {/* <PaginationContainer>
          <NavButton onClick={handlePrevPage} disabled={currentPage === 1}>
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.2893 5.70708C13.8988 5.31655 13.2657 5.31655 12.8751 5.70708L7.98768 10.5993C7.20729 11.3805 7.2076 12.6463 7.98837 13.427L12.8787 18.3174C13.2693 18.7079 13.9024 18.7079 14.293 18.3174C14.6835 17.9269 14.6835 17.2937 14.293 16.9032L10.1073 12.7175C9.71678 12.327 9.71678 11.6939 10.1073 11.3033L14.2893 7.12129C14.6799 6.73077 14.6799 6.0976 14.2893 5.70708Z"
                fill="var(--text-100)"
              />
            </svg>
          </NavButton>
          {renderPageNumbers()}
          <NavButton
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
          >
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.71069 18.2929C10.1012 18.6834 10.7344 18.6834 11.1249 18.2929L16.0123 13.4006C16.7927 12.6195 16.7924 11.3537 16.0117 10.5729L11.1213 5.68254C10.7308 5.29202 10.0976 5.29202 9.70708 5.68254C9.31655 6.07307 9.31655 6.70623 9.70708 7.09676L13.8927 11.2824C14.2833 11.6729 14.2833 12.3061 13.8927 12.6966L9.71069 16.8787C9.32016 17.2692 9.32016 17.9023 9.71069 18.2929Z"
                fill="var(--text-100)"
              />
            </svg>
          </NavButton>
        </PaginationContainer> */}
      </Section>
    </Container>
  );
};

export default BestSellerMain;
